module.exports = __webpack_public_path__ + "img/platform_big_001_border.32c22beb.png";